import { DOWNLOAD_REFERRALS, DOWNLOAD_REFERRALS_SUCCESS, DOWNLOAD_REFERRALS_ERROR, DOWNLOAD_REFERRALS_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const getDownloadReferrals = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_REFERRALS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_REFERRALS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_REFERRALS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DOWNLOAD_REFERRALS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getDownloadReferrals;
